export default __webpack_public_path__ + "assets/static/data/blog-data.7bdf17a307b828fcb7dae19bded81fb3.json";